import React, { useEffect, useState } from 'react';
import { Input, Button, Form, Select, Checkbox, Typography, Modal, notification } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { AuthUrl } from '../urls';
import { __hideLoader, __showLoader } from '../Redux Store/Slices/loader';

const { Text } = Typography;
const { Option } = Select;

const ProfilePage = () => {
    const { user } = useSelector(state => state.auth)
    const [isEditing, setIsEditing] = useState(false);
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const [api, contextHolder] = notification.useNotification();



    const [initialData, setInitialData] = useState({
        name: '',
        email: '',
        phone: '',
        userName: ''
    });
    useEffect(() => {
        if (user) {
            const newData = {
                name: user.name,
                userName: user.username,
                email: user.email,
                phone: user.phoneNumber,
            };
            setInitialData(newData);

            // Update form fields dynamically
            form.setFieldsValue(newData);
        }
    }, [user, form]);


    const handleEditClick = () => {
        setIsEditing(true);
    };

    const handleSaveClick = async () => {
        dispatch(__showLoader("Saving profile..."));

        try {
            const values = await form.validateFields();
            // const response = await axios.post(AuthUrl.username, data);


            console.log('Saved Data:', values);
            setIsEditing(false);

            // Simulating an API call or success notification
            api.open({
                message: "Success",
                description: "Profile updated successfully!",
                duration: 0,
            });

        } catch (error) {
            console.error('Validation Failed:', error);

            let errorMessage = "Validation failed. Please check the fields.";
            if (Array.isArray(error?.errorFields)) {
                errorMessage = error.errorFields.map(field => field.errors).join(", ");
            }

            api.open({
                message: "Error",
                description: errorMessage,
                duration: 0,
            });

        } finally {
            dispatch(__hideLoader());
        }
    };


    return (
        <div className="profile-page" style={{ padding: '20px', maxWidth: '600px', margin: 'auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                <h2>Profile</h2>
                {/* <Button
                    icon={<EditOutlined />}
                    onClick={handleEditClick}
                    type="primary"
                    disabled={isEditing}
                >
                    Edit
                </Button> */}
            </div>

            <Form form={form} layout="vertical">
                <Form.Item
                    label="Name"
                    name="name"
                    rules={[{ required: true, message: 'Please enter your name' }]}
                >
                    {isEditing ? <Input /> : <Text>{initialData.name}</Text>}
                </Form.Item>

                {/* <Form.Item
                    label="User Name"
                    name="userName"
                    rules={[
                        { required: true, message: 'Please enter your username' },
                        { min: 3, message: 'Username must be at least 3 characters' },
                    ]}
                >
                    {isEditing ? <Input /> : <Text>{initialData.userName}</Text>}
                </Form.Item> */}

                <Form.Item
                    label="Email"
                    name="email"
                    rules={[
                        { required: true, message: 'Please enter your email' },
                        { type: 'email', message: 'Please enter a valid email' },
                    ]}
                >
                    {isEditing ? <Input /> : <Text>{initialData.email}</Text>}
                </Form.Item>

                <Form.Item
                    label="Phone Number"
                    name="phone"
                    rules={[
                        { required: true, message: 'Please enter your phone number' },
                        {
                            pattern: /^\+?[1-9]\d{1,14}$/,
                            message: "Enter a valid phone number (e.g., +1234567890)",
                        },]}
                >
                    {isEditing ? <Input /> : <Text>{initialData.phone}</Text>}
                </Form.Item>

                {isEditing && (
                    <div style={{ textAlign: 'center' }}>
                        <Button onClick={() => setIsEditing(false)} style={{ marginRight: '10px' }}>
                            Cancel
                        </Button>
                        <Button onClick={handleSaveClick} type="primary">
                            Save
                        </Button>
                    </div>
                )}
            </Form>

        </div>
    );
};

export default ProfilePage;
